import React from 'react';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-left: 8px;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }

  transition: all 0.2s ease-in-out;

  svg {
    height: 18px;
    width: 18px;

    fill: ${({ theme }) => theme.themeColors.text};
  }
`;

export const NodeParameterRemoveButton = ({ onClick }) => {
  return (
    <Wrapper onClick={onClick} className="read-only-hide">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
      </svg>
    </Wrapper>
  );
};
